// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2145":"69c11d6f","5928":"73b740f0","7144":"73b740f0"}[chunkId] + ".chunk.css";
};